import BaseService from '../commons/BaseService';
import { eEthereumTxType, } from '../commons/types';
import { IERC1155__factory } from './typechain/IERC1155__factory';
export class ERC1155Service extends BaseService {
    constructor(provider) {
        super(provider, IERC1155__factory);
        this.contractInterface = IERC1155__factory.createInterface();
    }
    /**
     * Transfer tokens to another address
     * @param {string} user - Address of the user
     * @param {string} token - Token which the user is spending
     * @param {string} tokenId - Token id to transfer
     * @param {string} amount - Amount to transfer
     * @param {string} to - Address to transfer tokens to
     * @param {Bytes} params - Additional params
     * @returns {EthereumTransactionTypeExtended} Ethereum transaction object
     */
    transfer({ user, token, tokenId, amount, to, params }) {
        const erc1155Contract = this.getContractInstance(token);
        const txCallback = this.generateTxCallback({
            rawTxMethod: async () => erc1155Contract.populateTransaction.safeTransferFrom(user, to, tokenId, amount, params),
            from: user,
        });
        return {
            tx: txCallback,
            txType: eEthereumTxType.ERC1155_TRANSFER,
            gas: this.generateTxPriceEstimation([], txCallback),
        };
    }
    /**
     * Transfer tokens to another address
     * @param {string} user - Address of the user
     * @param {string} token - Token which the user is spending
     * @param {string} tokenId - Token id to transfer
     * @param {string} amount - Amount to transfer
     * @param {string} to - Address to transfer tokens to
     * @param {Bytes} params - Additional params
     * @returns {PopulatedTransaction} Transaction response
     */
    transferTxData({ user, token, tokenId, amount, to, params }) {
        const tx = {};
        const txData = this.contractInterface.encodeFunctionData('safeTransferFrom', [user, to, tokenId, amount, params]);
        tx.data = txData;
        tx.to = token;
        tx.from = user;
        return tx;
    }
}
//# sourceMappingURL=index.js.map